import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function claimedDomainValidator(domains: string[]): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!domains.length) {
      return null;
    }

    const domain = control.value.split('@')?.[1];
    return domains.includes(domain) ? null : { claimedDomain: true };
  };
}
